<template>
  <div class="form-floating date-picker-wrapper">
    <DatePicker
        v-model="internalDate"
        :format="format"
        :placeholder="label"
        :editable="false"
        :clearable="true"
        input-class="input"
        :lang="frLocale"
        :clear="clear"
    />
  </div>
</template>

<script>
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import fr from 'vue2-datepicker/locale/fr'

export default {
  name: 'DateInput',
  components: {DatePicker},
  props: {
    modelValue: [Date, null],
    label: {
      type: String,
      default: 'Date'
    },
    format: {
      type: String,
      default: 'YYYY-MM-DD' // Format used by vue2-datepicker
    },
  },
  data() {
    return {
      frLocale: {
        ...fr,
        weekStart: 1 // lundi
      }
    }
  },
  computed: {
    internalDate: {
      get() {
        return this.modelValue || null;
      },
      set(date) {
        this.$emit('update:modelValue', date);
        this.$emit('change', date);
      }
    }
  },
  methods: {
    clear() {
      this.internalDate = null;
    }
  }
}
</script>

<style scoped>
.input {
  position: relative;
  display: flex;
  align-items: center;
  background: white;
  min-height: 4vh;
  border: 1px solid #ccc;
  border-radius: 8px;
  cursor: pointer;
}
</style>
